<template>
    <div class="web_index">
    <BaseHeader></BaseHeader>

    <div style="width: 100%;height: 100px"></div>
    <div class="web_content">
        <div class="web_content_inner" v-html="respData.content"></div>
    </div>

        <component v-bind:is="'BaseBottom'"></component>
  </div>
</template>

<script>
    import BaseBottom from './BaseBottom.vue'
    import BaseHeader from './BaseHeader.vue'
    import router from '../../router'
export default {
    components: {BaseBottom: BaseBottom,BaseHeader},
  name: 'Index',
  data () {
    return {
        jumpType:4,
        respData:{}
    }
  },
  methods: {

      load: function (){
          let that = this
          this.$http.get('/admin/adwebs/getAdWeb', {params: {id: '1'}})
              .then(function (res) {
                  that.respData = res.data.adWeb
              }).catch(function (err) {
              console.log('er getAd' + err)
          })
      },
  },
  mounted () {
      this.load()
  },
    updated(){

    }
}
</script>


<style scoped="page">
    .web_index{
        width: 100%;
        background-color: #F0F4F5;
    }
    .web_title{
        width: 100%;
        height: 80px;
        background-color: #ffffff;
        position: fixed;
        top: 0;
        z-index: 1000;
    }
    .web_title_content{
        width: 1290px;
        height: 80px;
        margin: auto;
        position: relative;
    }
    .title_img{
        margin-left: 40px;
        margin-top: 18px;
    }
    .title_content{
        height: 80px;
        position: absolute;
        right:45px;
        top: 0;
    }
    .title{
        float: right;
        height: 80px;
        line-height: 80px;
        font-size: 18px;
    }
    .title_red{
        float: right;
        height: 70px;
        line-height: 80px;
        font-size: 18px;
        border-bottom: 2px solid #cd001b;
        color: #000000;
    }
  .web_content{
    width: 1210px;
    margin: auto;
    /*margin-top: 100px;*/
    margin-bottom: 60px;
    line-height: 16px;
    background-color: #FFFFFF;
      /*padding:20px 50px;*/
  ;
  }

  .web_content_inner{padding: 20px 50px;}




    .web_content_inner >>> p{margin: 0;font-size: 16px;line-height: 26px;font-family: initial !important;}
    .web_content_inner >>> span{margin: 0;font-size: 16px;line-height: 26px;font-family: initial !important;}


</style>



// WEBPACK FOOTER //
// src/components/web/JoinUs.vue